import { SvgIcon } from '@mui/material';

export function VerifiedIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M8.81208 21.8653L7.02758 18.8578L3.63908 18.1153L3.96983 14.627L1.67383 12L3.96983 9.37301L3.63908 5.88477L7.02758 5.14227L8.81208 2.13477L12.0006 3.48851L15.1891 2.13477L16.9736 5.14227L20.3621 5.88477L20.0313 9.37301L22.3273 12L20.0313 14.627L20.3621 18.1153L16.9736 18.8578L15.1891 21.8653L12.0006 20.5115L8.81208 21.8653ZM9.45058 19.95L12.0006 18.8693L14.5813 19.95L16.0006 17.55L18.7506 16.9193L18.5006 14.1L20.3506 12L18.5006 9.86927L18.7506 7.05002L16.0006 6.45002L14.5506 4.05002L12.0006 5.13076L9.41983 4.05002L8.00058 6.45002L5.25058 7.05002L5.50058 9.86927L3.65058 12L5.50058 14.1L5.25058 16.95L8.00058 17.55L9.45058 19.95ZM10.9506 15.2038L16.2543 9.90002L15.2006 8.81552L10.9506 13.0655L8.80058 10.9463L7.74683 12L10.9506 15.2038Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
